import axios from 'axios';
import { getTokenPayload } from '../globals';
import router from '../routes'

export class Auth {

    private readonly TOKEN_KEY = "AUTH_TOKEN";
    private readonly USER_KEY = "AUTH_USER";
    private readonly PROJECT_KEY = "AUTH_PROJECT";

    getMode() {
        return localStorage.getItem('MODE');
    }

    isVertebra() {
        const payload = getTokenPayload(this.getToken());
        return payload.vertebra;
    }

    isSuperadmin() {
        const payload = getTokenPayload(this.getToken());
        return payload.issuperadmin || payload.superadmin;
    }

    setToken(token: string): void {
        localStorage.setItem(this.TOKEN_KEY, token);
    }

    getToken(): string {
        return localStorage.getItem(this.TOKEN_KEY) || '';
    }

    getModules() : string[] {
        const payload = getTokenPayload(this.getToken());
        return payload.modules;
    }   


    getRol() {
        // if (!this.isVertebra()) {
        //     axios({
        //         method: "GET",
        //         "url": `user/rol`
        //     }).then(res => {
        //         const usr = this.getUser();
        //         usr.rol = res.data.rol;
        //         this.setUser(usr);
        //     })
        // }
        const payload = getTokenPayload(this.getToken());
        return payload.rol;
    }

    setUser(user: any): void {
        localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    }

    getUser() {
        try {
            const user = JSON.parse(localStorage.getItem(this.USER_KEY) || '');
            return user;
        } catch (e) {
            return null;
        }
    }

    setProject(project: any): void {
        localStorage.setItem(this.PROJECT_KEY, JSON.stringify(project));
    }

    getProject() {
        try {
            const user = JSON.parse(localStorage.getItem(this.PROJECT_KEY) || '');
            return user;
        } catch (e) {
            return null;
        }
    }

    async login(creds: ILoginCreds) {
        const request = await axios({
            method: "POST",
            "url": `${process.env.VUE_APP_BACKEND}/login`,
            data: creds
        });
        return request;
    }

    logout() {
        localStorage.removeItem('MODE');
        localStorage.removeItem(this.USER_KEY);
        localStorage.removeItem(this.TOKEN_KEY);
        localStorage.removeItem(this.PROJECT_KEY);
        router.push("/")
    }

}

export const oAuth = new Auth;

interface ILoginCreds {
    username: string;
    password: string;
}